import React from 'react';
import { Box, Button, Divider, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AdvancedSearchBar, { AdvancedSearchParams } from '../components/AdvancedSearchBar';

interface TabletFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  initialParams: AdvancedSearchParams;
  recentSearches?: string[];
  onSearch: (params: AdvancedSearchParams) => void;
  onResetAll: () => void;
}

export default function TabletFilterDrawer({
  open,
  onClose,
  initialParams,
  recentSearches = [],
  onSearch,
  onResetAll,
}: TabletFilterDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 440, maxWidth: '92vw', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Filter
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button onClick={onResetAll} size="small">
              Rensa alla
            </Button>
            <IconButton onClick={onClose} aria-label="Stäng filter">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
          <AdvancedSearchBar
            filtersOnly
            onSearch={onSearch}
            initialParams={initialParams}
            recentSearches={recentSearches}
          />
        </Box>
      </Box>
    </Drawer>
  );
}
